import {
  GET_FOLLOWUPS,
  ADD_FOLLOWUP,
  EDIT_FOLLOWUP,
  GET_FOLLOWUP,
  RESET_FOLLOWUP,
  GET_ALL_FOLLOWUPS,
  ERROR_FOLLOWUP,
  GET_LEAD_FOLLOWUPS,
} from "../types/followup_type";

const initialState = {
  followups: null,
  page: null,
  pages: null,
  followup: null,
  total_followups: 0,
  loading: true,
  error: {},
  followup_message: null,
  all_followups: null,
  lead_followups: null,
};

export const followup_reducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_FOLLOWUPS:
      return {
        ...state,
        followups: payload.followups,
        pages: payload.pages,
        page: payload.page,
        total_followups: payload.count,
        loading: false,
        error: {},
      };
    case GET_ALL_FOLLOWUPS:
      return {
        ...state,
        all_followups: payload,
        loading: false,
        error: {},
      };
    case GET_LEAD_FOLLOWUPS:
      return {
        ...state,
        lead_followups: payload,
        loading: false,
        error: {},
      };

    case RESET_FOLLOWUP:
      return {
        ...state,
        followup: null,
        loading: true,
        lead_followups: null,
        error: {},
      };

    case ADD_FOLLOWUP:
      return {
        ...state,
        followup_message: payload,
        loading: false,
        error: {},
      };
    case GET_FOLLOWUP:
      return {
        ...state,
        followup: payload,
        loading: false,
        error: {},
      };
    case EDIT_FOLLOWUP:
      return {
        ...state,
        followup_message: payload,
        loading: false,
        error: {},
      };
    case ERROR_FOLLOWUP:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    default:
      return state;
  }
};
